
import { CategoryManager } from '../features/blog/components/CategoryManager/CategoryManager';

export const BlogCategoriesPage = () => <CategoryManager />;
